// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { Analytics } from '@trello/atlassian-analytics';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { View } from 'app/scripts/views/internal/view';
import template from 'app/scripts/views/templates/popover_confirmation_public_boards';
import { BoardMemberAddMultipleView } from 'app/scripts/views/board-menu/BoardMemberAddMultipleView';
import Dialog from 'app/scripts/views/lib/dialog';
import { featureFlagClient } from '@trello/feature-flag-client';
import {
  LazyBoardInviteModal,
  dialogProps,
} from 'app/src/components/BoardInviteModal';

class ConfirmationPublicBoardsView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'change to public';

    this.prototype.className = 'confirmation-popover';

    this.prototype.events = {
      'click .js-submit': 'selectVis',
      'click .js-action-link': 'renderInvitationLink',

      'mouseenter .js-action-link': 'mouseenter',
      'mouseleave .js-action-link': 'mouseleave',
    };
  }

  render() {
    const data = this.model.toJSON();
    data.isTemplate = this.model.isTemplate();

    this.$el.html(template(data));

    return this;
  }

  selectVis(e) {
    stopPropagationAndPreventDefault(e);

    const traceId = Analytics.startTask({
      taskName: 'edit-board/prefs/permissionLevel',
      source: 'makeBoardPublicInlineDialog',
    });

    const change = this.model.getPref('permissionLevel') !== 'public' ? 1 : 0;

    this.model.setPrefWithTracing('permissionLevel', 'public', {
      taskName: 'edit-board/prefs/permissionLevel',
      source: 'makeBoardPublicInlineDialog',
      traceId,
      next: (_err, res) => {
        if (res) {
          Analytics.sendUpdatedBoardFieldEvent({
            field: 'visibility',
            value: 'public',
            source: 'makeBoardPublicInlineDialog',
            containers: {
              board: {
                id: this.model.id,
              },
              organization: {
                id: this.model.getOrganization()?.id,
              },
              enterprise: {
                id: this.model.getEnterprise()?.id,
              },
            },
            attributes: {
              change,
              taskId: traceId,
            },
          });
        }
      },
    });

    this.model.save();

    return PopOver.hide();
  }

  renderInvitationLink(e) {
    stopPropagationAndPreventDefault(e);
    if (featureFlagClient.get('smoothie.board-invite-popover', false)) {
      Dialog.show({
        reactElement: (
          <LazyBoardInviteModal
            idBoard={this.model.id}
            idOrg={this.model.getOrganization()?.id}
            onClose={Dialog.hide}
          />
        ),
        ...dialogProps,
      });
      $(
        featureFlagClient.get('smoothie.board-invite-popover', false) &&
          featureFlagClient.get('smoothie.board-share-spotlight', false)
          ? '.board-share-button'
          : '.js-open-manage-board-members',
      ).removeClass('open-manage-boards-offset');
    } else {
      const view = new BoardMemberAddMultipleView({
        model: this.model,
        modelCache: this.modelCache,
      });
      view.loadOrgData();
      $('.js-open-manage-board-members').removeClass(
        'open-manage-boards-offset',
      );

      PopOver.toggle({
        elem: $('.js-open-manage-board-members'),
        view,
      });
    }

    Analytics.sendClickedLinkEvent({
      linkName: 'openShareMenuLink',
      source: 'changeBoardVisiblityToPublicConfirmationInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
        enterprise: {
          id: this.model.getEnterprise()?.id,
        },
      },
    });
  }

  mouseenter(e) {
    return $(
      featureFlagClient.get('smoothie.board-invite-popover', false) &&
        featureFlagClient.get('smoothie.board-share-spotlight', false)
        ? '.board-share-button'
        : '.js-open-manage-board-members',
    ).addClass('open-manage-boards-offset');
  }

  mouseleave(e) {
    return this.setTimeout(
      () =>
        $(
          featureFlagClient.get('smoothie.board-invite-popover', false) &&
            featureFlagClient.get('smoothie.board-share-spotlight', false)
            ? '.board-share-button'
            : '.js-open-manage-board-members',
        ).removeClass('open-manage-boards-offset'),
      0,
    );
  }
}

ConfirmationPublicBoardsView.initClass();
export { ConfirmationPublicBoardsView };
